import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  empty: {
    color: tokens.colorNeutralForeground3,
    padding: tokens.spacingVerticalL,
  },
  channelName: {
    fontFamily: tokens.fontFamilyMonospace,
    fontWeight: tokens.fontWeightSemibold,
  },
  preview: {
    color: tokens.colorNeutralForeground2,
    fontStyle: 'italic',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    maxWidth: '480px',
  },
  numCell: {
    fontVariantNumeric: 'tabular-nums',
    color: tokens.colorNeutralForeground2,
  },
  rawToggle: {
    marginTop: tokens.spacingVerticalM,
  },
  rawPre: {
    margin: 0,
    padding: tokens.spacingVerticalS,
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: tokens.borderRadiusSmall,
    fontFamily: tokens.fontFamilyMonospace,
    fontSize: tokens.fontSizeBase200,
    maxHeight: '320px',
    overflow: 'auto',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
});
